import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllFoodTypesResponse, FoodTypeResponse, FoodTypesDto } from '@gtpl/shared-models/masters';
import { Body, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { FoodTypeAdapter } from './dto/food-type.adapter';
import { FoodTypeDTO } from './dto/food-types.dto';
import { FoodType } from './food-types.entitiy';
import { LogActions, LoggerInstantiation } from 'apps/services/logger/logger-functions';
import { FoodTypeRequest } from './dto/food-type.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';


@Injectable()
export class FoodTypesService {
    constructor(
      private logService:LogsService,

        @InjectRepository(FoodType) private foodTypeRepository: Repository<FoodType>,
        private foodTypeAdapter: FoodTypeAdapter,
      ) { }
      
      async createFoodType(foodTypesDto: FoodTypeDTO, isUpdate: boolean,request:Request): Promise<FoodTypeResponse> {
          try {
          let previousValue
          // console.log(isUpdate); 
          //this section will be executed while creating a new user only
          if (!isUpdate) {
            // console.log(isUpdate); 
    
              const foodTypeEntity = await this.getDuplicateFoodType(foodTypesDto.foodTypeCode);
              // console.log(foodTypeEntity);
            if (foodTypeEntity) {
             
              // return true;
              throw new FoodTypeResponse(false,11104, 'Food Type already exists');
            }
          }
          else{
            const certificatePrevious = await this.foodTypeRepository.findOne({where:{foodTypeId:foodTypesDto.foodTypeId}})
            previousValue = certificatePrevious.foodType+' , '+certificatePrevious.foodTypeCode
            const foodTypeEntity = await this.getDuplicateFoodType(foodTypesDto.foodTypeCode);
            if(foodTypeEntity){
                if(foodTypeEntity.foodTypeId!=foodTypesDto.foodTypeId) {
                    throw new FoodTypeResponse(false,11104, 'Food Type already exists');      
                }
            }
        }
      
          const convertedFoodTypeEntity: FoodType = this.foodTypeAdapter.convertDtoToEntity(foodTypesDto,isUpdate);
          const savedFoodEntity: FoodType = await this.foodTypeRepository.save(convertedFoodTypeEntity);
          const savedFoodTypeDto: FoodTypeDTO = this.foodTypeAdapter.convertEntityToDto(savedFoodEntity);
         
           if (savedFoodTypeDto) {
            const certificatePresent = savedFoodTypeDto.foodType+" , "+savedFoodTypeDto.foodTypeCode;
            const response = new FoodTypeResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Food Type Updated Successfully':'Food Type Created Successfully',savedFoodTypeDto);
            const name=isUpdate?'updated':'created'
            const displayValue = isUpdate? 'Food Type Updated Successfully': 'Food Type Created Successfully'
            const userName = isUpdate? savedFoodTypeDto.updatedUser :savedFoodTypeDto.createdUser;
            const newLogDto = new LogsDto(1,name, 'FoodType', savedFoodTypeDto.foodTypeId, true, displayValue,userName,previousValue,certificatePresent)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            
            return response;
          } else {
            throw new FoodTypeResponse(false,11106,'Food Type saved but issue while transforming into DTO');
          }
        }
        catch (error) {
          return error;
        }
      }

         /**
     * gets all  procurement types details  
     * @returns all the procurement type details .
     */
  // @LogActions({ isAsync: true })
  async getAllFoodTypes(req?: UserRequestDto): Promise<AllFoodTypesResponse> {  
    try {
      const foodTypeDtos: FoodTypesDto[] = [];
      // retrieves all plants
      const foodTypeEntities: FoodType[] = await this.foodTypeRepository.find({
        order: { foodType: "ASC" },
      });
    //   console.log(foodTypeEntities);
      if (foodTypeEntities.length>0) {
        foodTypeEntities.forEach(foodTypeEntity => {
          const convertedFoodTypeDto: FoodTypesDto = this.foodTypeAdapter.convertEntityToDto(foodTypeEntity);
          foodTypeDtos.push(convertedFoodTypeDto);
        });
        const response = new AllFoodTypesResponse(true, 11208, "Food Types retrieved successfully", foodTypeDtos);
        if(req?.createdUser){
          const newLogDto = new LogsDto(1,'view', 'FoodType', 0, true, 'Food Types retrieved successfully',req.createdUser,'','',)
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
        }
      
        return response;
      } else {
        //   console.log('yest')
        throw new FoodTypeResponse(false,99998, 'No Records Found');
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllActiveFoodTypes(): Promise<AllFoodTypesResponse> {
    // const page: number = 1;
    try {
        const foodTypeDtos: FoodTypesDto[] = [];
        //retrieves all companies
        const foodTypeEntities: FoodType[] = await this.foodTypeRepository.find({ order: { foodType: 'ASC' },where:{isActive:true},
       });
     console.log(foodTypeEntities)
        if (foodTypeEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            foodTypeEntities.forEach(foodTypeEntity => {
                const convertedFoodTypeDto: FoodTypesDto = this.foodTypeAdapter.convertEntityToDto(
                  foodTypeEntity
                );
                foodTypeDtos.push(convertedFoodTypeDto);
            });
            const response = new AllFoodTypesResponse(true, 11108, "FoodTypes retrieved successfully", foodTypeDtos);
            return response;
        } else {
            throw new FoodTypeResponse(false,99998, 'Data not found'); foodTypeDtos
        }
    } catch (err) {
        throw err;
    }
}  

       /**
     * It deactivates Food type 
     * @param foodTypeRequest Food type  as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateFoodType(foodTypeRequest: FoodTypeRequest): Promise<FoodTypeResponse>{
        try {
            const FoodTypeExists = await this.getFoodTypeById(foodTypeRequest.foodTypeId);
            if (FoodTypeExists) {
                if (foodTypeRequest.versionFlag !== FoodTypeExists.versionFlag) {
                    throw new FoodTypeResponse(false,10113, 'Someone updated the current Food Type information.Refresh and try again');
                } else {
                    
                        const foodTypeSatatus =  await this.foodTypeRepository.update(
                            { foodTypeId: foodTypeRequest.foodTypeId },
                            { isActive: foodTypeRequest.isActive,updatedUser: foodTypeRequest.updatedUser });
                       
                        if (FoodTypeExists.isActive) {
                            if (foodTypeSatatus.affected) {
                                const foodTypeResponse: FoodTypeResponse = new FoodTypeResponse(true, 10115, 'Food Type is de-activated successfully');
                                return foodTypeResponse;
                            } else {
                                throw new FoodTypeResponse(false,10111, 'Food Type is already deactivated');
                            }
                        } else {
                            if (foodTypeSatatus.affected) {
                                const foodTypeResponse: FoodTypeResponse = new FoodTypeResponse(true, 10114, 'Food Type is activated successfully');
                                return foodTypeResponse;
                            } else {
                                throw new FoodTypeResponse(false,10112, 'Food Type is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new FoodTypeResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getFoodTypes(foodTypeId: number): Promise<FoodType> {
    //  console.log(employeeId);
        const employeeResponse = await this.foodTypeRepository.findOne({
          where: {foodTypeId: Raw(alias => `food_type_id = '${foodTypeId}'`)},
        });
        // console.log(employeeResponse);
        if (employeeResponse) {
        return employeeResponse;
        } else {
        return null;
        }
    }

    async getDuplicateFoodType(foodTypeCode: string): Promise<FoodType> {
      //  console.log(employeeId);
          const response = await this.foodTypeRepository.findOne({
          where: {foodTypeCode: foodTypeCode},
          });
          // console.log(response);
          if (response) {
          return response;
          } else {
          return null;
          }
      }

    async getFoodTypeById(foodTypeId: number): Promise<FoodType> {
    //  console.log(employeeId);
        const employeeResponse = await this.foodTypeRepository.findOne({
        where: {foodTypeId: foodTypeId},
        });
        // console.log(employeeResponse);
        if (employeeResponse) {
        return employeeResponse;
        } else {
        return null;
        }
    }

    async getFoodTypeDataById(@Body() foodTypeRequest:FoodTypeRequest): Promise<FoodTypeResponse> {
      // const page: number = 1;
      try {
        const foodTypeDTO: FoodTypesDto[] = [];
        //retrieves all companies
        const foodTypeEntities: FoodType = await this.foodTypeRepository.findOne({
          //   relations:["CusAddressInfo"],
          where:{foodTypeId:foodTypeRequest.foodTypeId}
          });
          
          const foodTypesData: FoodTypesDto = this.foodTypeAdapter.convertEntityToDto(foodTypeEntities);
          if (foodTypesData) {
              const response = new FoodTypeResponse(true, 11101 , 'Food Type retrived Successfully',foodTypesData);
              return response;
          }
          else{
              throw new FoodTypeResponse(false,11106,'Something went wrong');
          }
          // generating resposnse
          
      } catch (err) {
        throw err;
      }
    }
}
